module.exports = __webpack_public_path__ + "media/images/icons/flags/SX-045c6db15c3ceb5bb2bfd827ee45dbd8.svg";